// import React, { useState } from 'react';
// import './LatestOrder.css';
// import { IoIosArrowDown } from "react-icons/io";
// import { getReadableOrderId } from 'pages/utils/HelperFun';

// const LatestOrder = ({ MainName, status, OrderId, OrderDate, Cost, orderdatespan, onAccept, onRefuse, onComplted,Item }) => {
//   const [isDropdownVisible, setDropdownVisible] = useState(false);
// console.log(Item,'ItemaLatest Order')
//   const getStatusBorderColor = () => {
//     if (status === 'completed') return '#009B10';
//     if (status === 'ongoing' || status === 'inprocess') return '#FF9900';
//     return 'gray';
//   };

//   const getStatusColor = () => {
//     if (status === 'completed') return '#009B10';
//     if (status === 'ongoing' || status === 'inprocess') return '#FF9900';
//     return 'gray';
//   };

//   const handleAccept = () => {
//     onAccept(OrderId);
//     setDropdownVisible(false);
//   };

//   const handleRefuse = () => {
//     onRefuse(OrderId);
//     setDropdownVisible(false);
//   };

//   const handleComplted = () => {
//     onComplted(OrderId);
//     setDropdownVisible(false);
//   };

//   return (
//     <div className="latestOrder">
//       <div className="main-div-latest-order">
//         <div>
//           <h5 className="heading-h5-later">{MainName || 'Harry Makfee'}</h5>
//         </div>
//         {Item?.isExpired && (
//     <h5 className="paragprh-customer-com  text-red-600 bg-red-100 px-2 py-1 rounded-full mr-[-12px]">
//       Expired
//     </h5>
//   )}
//   {Item?.isExpired === false && (
//      <div>
//         {status === 'ongoing' || status === 'inprocess' ? (
//           <div className="div-btn-button" style={{ border: `1px solid ${getStatusBorderColor()}` }}>
//             <button 
//               className="btn-main-later flex items-center gap-1 text-[11px]" 
//               style={{ color: getStatusColor(), display: 'flex', alignItems: 'center',paddingBottom:'0px', }} 
//               onClick={() => setDropdownVisible(!isDropdownVisible)}
//             >
//               {status === 'ongoing' ? 'New Order' : 'In Process'}
//               <IoIosArrowDown style={{fontSize:15}} />

//             </button>

//             {isDropdownVisible && (
//               <div className="dropdown text-center p-[5px] overflow-hidden">
//                 {status === 'ongoing' && (
//                   <>
//                   <button 
//   className="block w-full text-[10px] rounded-[5px]  text-[#009b10] px-1 py-1 text-center hover:text-[#747EEF]"
//   onClick={handleAccept}
//   style={{ color: '#009b10',border:'1px solid #009b10'}}
// >
//   Accept
// </button>

// <button
//   className="block w-full  text-[10px] rounded-[5px]  text-[#bb2124] px-1 py-1 text-center hover:text-[#747EEF]"
//   onClick={handleRefuse}
//   style={{ color: '#bb2124',border:'1px solid #bb2124',marginTop:'2px'}}
// >
//   Refuse
// </button>

//                   </>
//                 )}
//                 {status === 'inprocess' && (
//                   <button
//                     onClick={handleComplted}
//                     className="block w-full text-[10px] rounded-[5px]  px-1 py-1 text-center hover:text-[#747EEF]"
//                     style={{ color: '#009b10',border:'1px solid #009b10'}}
//                   >
//                     Completed
//                   </button>
//                 )}
//               </div>
//             )}
//           </div>
//         ) : status === 'completed' ? (
//           <div className="div-btn-button p-[0px] overflow-hidden" style={{ border: `1px solid ${getStatusBorderColor()}` }}>
//             <button className="btn-main-later" style={{ color: getStatusColor() }}>
//               Completed
//             </button>
//           </div>
//         ) : null}
//       </div> 
//   )}

// </div>
//       <div className="main-div-latest-order" style={{ marginTop: 15, marginBottom: 2 }}>
//         <div className="div-order-inner">
//           <p className="paragph-heading">Order ID:</p>
//           <h5 className="heading-h5-later">{getReadableOrderId(OrderId)}</h5>
//         </div>
//         <div className="div-order-inner">
//           <p className="paragph-heading">Order Date:</p>
//           <h5 className="heading-h5-later">
//             {OrderDate} {orderdatespan && <span style={{ fontSize: 9 }}>AED</span>}
//           </h5>
//         </div>
//         <div className="div-order-inner">
//           <p className="paragph-heading">Cost:</p>
//           <h5 className="heading-h5-later">{Cost} AED</h5>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LatestOrder;

import React, { useState } from 'react';
import { IoIosArrowDown, IoMdPin, IoIosCar } from "react-icons/io";
import { getReadableOrderId } from 'pages/utils/HelperFun';
import { fontFamily, fontWeight } from '@mui/system';

const LatestOrder = ({ MainName, status, OrderId, OrderDate, Cost, orderdatespan, onAccept, onRefuse, onComplted, Item }) => {
  const [isDropdownVisible, setDropdownVisible] = useState(false);
console.log(Item,'ItemaLatest Order')
  // Status colors logic
  const getStatusConfig = () => {
    if (status === 'completed') return { color: '#009B10', bg: '#E8F5E9' };
    if (status === 'ongoing' || status === 'inprocess') return { color: '#FF9900', bg: '#FFF3E0' };
    return { color: '#757575', bg: '#F5F5F5' };
  };

  const statusStyle = getStatusConfig();

  return (
    <div style={{
      backgroundColor: '#fff',
      borderRadius: '12px',
      padding: '14px',
      marginBottom: '15px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
      border: '1px solid #f0f0f0',
      fontFamily: '"General Sans", sans-serif !important'
    }}>
      
      {/* --- TOP SECTION: Name, Shop & Status --- */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
        <div style={{ flex: 1 }}>
          <h5 style={{ margin: 0, fontSize: '15px', fontWeight: '700', color: '#747EEF',fontFamily: '"General Sans", sans-serif !important' }}>
            {Item?.shopId?.shopName || 'Shop Name Unavailable'} 
            {/* <span style={{ fontSize: '11px', color: '#747EEF', marginLeft: '6px', fontWeight: '500' }}>
              • {Item?.shopId?.shopName || 'No Shop'}
            </span> */}
          </h5>
          <p style={{ margin: '2px 0 0 0', fontSize: '11px', color: '#888',fontFamily: 'Manrope' }}>{getReadableOrderId(OrderId)}</p>
        </div>

        {Item?.isExpired ? (
          <span style={{ backgroundColor: '#FFEBEE', color: '#D32F2F', padding: '4px 10px', borderRadius: '20px', fontSize: '10px', fontWeight: 'bold' }}>Expired</span>
        ) : (
          <div style={{ position: 'relative' }}>
            <button 
              onClick={() => setDropdownVisible(!isDropdownVisible)}
              style={{
                display: 'flex', alignItems: 'center', gap: '4px',
                padding: '5px 10px', borderRadius: '6px', fontSize: '11px', fontWeight: '600',
                border: `1px solid ${statusStyle.color}`, color: statusStyle.color,
                backgroundColor: 'transparent', cursor: 'pointer'
              }}
            >
              {status === 'ongoing' ? 'New Order' : status === 'inprocess' ? 'In Process' : 'Completed'}
              {(status !== 'completed') && <IoIosArrowDown />}
            </button>

            {isDropdownVisible && status !== 'completed' && (
              <div style={{
                position: 'absolute', right: 0, top: '110%', zIndex: 10,
                backgroundColor: '#fff', boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                borderRadius: '8px', padding: '6px', width: '110px', border: '1px solid #eee'
              }}>
                {status === 'ongoing' && (
                  <>
                    <button onClick={() => { onAccept(OrderId); setDropdownVisible(false); }} style={dropdownBtnStyle('#009b10')}>Accept</button>
                    <button onClick={() => { onRefuse(OrderId); setDropdownVisible(false); }} style={{ ...dropdownBtnStyle('#bb2124'), marginTop: '4px' }}>Refuse</button>
                  </>
                )}
                {status === 'inprocess' && (
                  <button onClick={() => { onComplted(OrderId); setDropdownVisible(false); }} style={dropdownBtnStyle('#009b10')}>Completed</button>
                )}
              </div>
            )}
          </div>
        )}
      </div>

      {/* --- CAR DETAILS SECTION --- */}
      <div style={{ 
        display: 'flex', gap: '10px', backgroundColor: '#f1f2fd', 
        padding: '10px', borderRadius: '8px', marginBottom: '12px',border:'1px solid #7d7eff  '
      }}>
        <div style={{ backgroundColor: '#747EEF', padding: '6px', borderRadius: '6px', display: 'flex', alignItems: 'center' }}>
          <IoIosCar size={20} color="white" />
        </div>
        <div>
          <h6 style={{ margin: 0, fontSize: '12px', color: '#333', fontWeight: '600' }}>
            {Item?.vehicleId?.vehicleManufacturer} {Item?.vehicleId?.vehicleName}
          </h6>
          <p style={{ margin: 0, fontSize: '11px', color: '#666' }}>
            Plate: <span style={{ color: '#000', fontWeight: '700' }}>{Item?.vehicleId?.vehiclePlateNumber}</span>
          </p>
        </div>
      </div>

      {/* --- LOCATIONS SECTION --- */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '8px', marginBottom: '12px' }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '6px' }}>
          <IoMdPin size={14} color="#FF5252" style={{ marginTop: '2px' }} />
          <div>
            <p style={labelStyle}>Customer Location</p>
            <p style={addressStyle}>{Item?.location?.text || 'N/A'}</p>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '6px' }}>
          <IoMdPin size={14} color="#4CAF50" style={{ marginTop: '2px' }} />
          <div>
            <p style={labelStyle}>Parking Spot</p>
            <p style={{ ...addressStyle, color: '#2E7D32', fontWeight: '600' }}>{Item?.carParkedAt || 'Not specified'}</p>
          </div>
        </div>
      </div>

      {/* --- FOOTER: Date & Cost --- */}
      <div style={{ 
        display: 'flex', justifyContent: 'space-between', alignItems: 'center', 
        borderTop: '1px dashed #DDD', paddingTop: '10px' 
      }}>
        <div>
          <p style={labelStyle}>Order Date</p>
          <p style={{ margin: 0, fontSize: '11px', color: '#333' }}>{OrderDate}</p>
        </div>
        <div style={{ textAlign: 'right' }}>
          <p style={labelStyle}>Total Price</p>
          <p style={{ margin: 0, fontSize: '14px', fontWeight: '800', color: '#000' }}>
           {Number(Item?.finalCost).toFixed(2)} <span style={{ fontSize: '10px' }}>AED</span>
          </p>
        </div>
      </div>
    </div>
  );
};

// --- Reusable Inline Styles ---
const labelStyle = {
  margin: 0,
  fontSize: '10px',
  color: '#747EEF',
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
  fontWeight: '600',
  fontFamily: '"General Sans", sans-serif !important'
};

const addressStyle = {
  margin: 0,
  fontSize: '11px',
  color: '#444',
  lineHeight: '1.3',
  fontFamily: 'Manrope'
};

const dropdownBtnStyle = (color) => ({
  width: '100%',
  padding: '6px',
  fontSize: '10px',
  borderRadius: '4px',
  border: `1px solid ${color}`,
  color: color,
  backgroundColor: '#fff',
  cursor: 'pointer',
  textAlign: 'center',
  fontWeight: '600'
});

export default LatestOrder;